export const PAYMENT_TYPES = {
  CARD: "card",
  SMS: "sms",
  CASH: "cash"
};

export default PAYMENT_TYPES;
